import { SelectChangeEvent } from "src/components/MuiGenerals";

import { useBatchContractSweepFormContext } from "../../../contexts";
import SpenderAddressSelection from "src/components/SpenderAddress/SpenderAddressSingleSelection";

function SpenderAddressSingleSelection({
  value,
  onChange,
}: {
  value: string;
  onChange: (e: SelectChangeEvent<string>) => void;
}) {
  const { translate: t, fields } = useBatchContractSweepFormContext();
  const label = t("spender_address");

  return (
    <>
      <div>{label}</div>
      <SpenderAddressSelection
        value={value}
        fieldName={label}
        onChange={onChange}
        chainName={fields.chainName}
        currency={fields.currency}
      />
    </>
  );
}

export default SpenderAddressSingleSelection;
